import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";

import { CollectionUploadedView } from "../../../../components/DirectDeposit/Transactions/CollectionUploadedView";


export interface ICollectionUploadedViewPage { }

export const CollectionUploadedViewPage: FC<ICollectionUploadedViewPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="File Details"
			breadcrumbCurrentPageName=""
			// breadcrumbLinks={[]}
			mainContents={<CollectionUploadedView />}
		/>
	);
};
